import React from 'react';
import { SongCard } from '@components/basics/SongCard';

export const PurchaseCardSkeleton = () => {
  return (
    <SongCard
      isPlaying={false}
      album={false}
      edition={false}
      expanded={null}
      setExpanded={null}
      loading
    >
      <SongCard.Cover
        image={null}
        onPlayButtonClick={() => {
          return;
        }}
      />
      <SongCard.Info
        header={null}
        subheader={null}
        actions={null}
        // This helps to keep the skeleton in the same place
        bottom={<SongCard.Info.Button label="just something" variant="primary" />}
      />
    </SongCard>
  );
};
